import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { CommonOutletsComponent } from './outlets/common-outlets/common-outlets.component';
import { UnauthenOutletsComponent } from './outlets/unauthen-outlets/unauthen-outlets.component';
import { CalendarComponent } from './pages/calendar/calendar.component';
import { EServiceComponent } from './pages/e-service/e-service.component';
import { ShopNTravelComponent } from './pages/e-service/shop-n-travel/shop-n-travel.component';
import { HomeComponent } from './pages/home/home.component';
import { MembershipListComponent } from './pages/membership/membership-list/membership-list.component';
import { SandboxComponent } from './pages/sandbox/sandbox.component';

export const routes: Routes = [
    {
        path: '',
        component: CommonOutletsComponent,
        canActivate: [authGuard],
        children: [
            { path: '', component: HomeComponent },
            { path: 'calendar', component: CalendarComponent },
            { path: 'e-service', component: EServiceComponent },
            {
                path: 'membership', loadChildren: () =>
                    import(
                        './pages/membership/membership.routes'
                    ).then((r) => r.MemberShipRoutes),
            },
            { path: 'agri', component: MembershipListComponent },
            { path: 'shop-and-travel', component: ShopNTravelComponent },
            {
                path: 'profile',
                loadChildren: () =>
                    import(
                        './pages/profile/profile.routes'
                    ).then((r) => r.ProfileRoutes),
            },

        ]
    },
    {
        path: 'sandbox',
        component: CommonOutletsComponent,
        // component: MapsOutletsComponent,
        children: [
            { path: '', component: SandboxComponent },
        ]


    },
    {
        path: 'auth',
        component: UnauthenOutletsComponent,
        loadChildren: () =>
            import(
                './pages/auth/auth.routes'
            ).then((r) => r.AuthRoutes),

    },
];
